<div class="container-box">
  <app-table-header (btnUpdateClick)="loadBrands()" tableTitle="Marche">
    <app-button-new-brand
      [refreshTableList]="refreshTableList"
      action-button
    ></app-button-new-brand>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      [settings]="settings"
      [source]="source"
      class="table-content"
      id="brandTable"
    ></ng2-smart-table>
  </div>
</div>
